export const tabs = ['People', 'Planets', 'Films', 'Species', 'Vehicles', 'Starships'];
export const url = 'https://swapi.dev/api/';
export const tableSize = 3;